<template>
    <tr>
        <td>{{ entry.date_entered }}</td>
        <td>{{ entry.owner_name }}</td>
        <status-icon-cell :data="data" :value="entry.status" />
        <comment-cell
            :comment="entry.comment"
            :username="entry.entered_user_name"
        />
    </tr>
</template>

<script>
import StatusIconCell from '../cells/StatusIconCell.vue';
import CommentCell from '../cells/CommentCell.vue';

export default {
    components: { StatusIconCell, CommentCell },
    props: {
        data: Object,
        entry: Object,
    },
};
</script>
